var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvgquimica1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 457.14 409.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n.d,.e,.f{stroke:#fff;stroke-miterlimit:10;}\r\n.d,.e,.f,.g{fill:none;}\r\n.e{stroke-linecap:round;}\r\n.e,.f{stroke-width:10px;}\r\n.d{stroke-width:4px;}\r\n.h{clip-path:url(#b);}\r\n"), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "g",
    points: "300.63 219 284.6 224.94 269.88 253.03 192.34 405 103.83 404.5 11.63 336 0 204.5 25.63 138 125.8 127.2 125.8 169.41 206.8 167.71 206.8 128.9 239.63 120 300.63 219"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "f",
    points: "33.13 404.5 448.99 404.5 360.13 229.5 360.13 94 283.63 94 283.63 226 193.63 403"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 323.63,
    y1: 178,
    x2: 360.13,
    y2: 178
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 323.63,
    y1: 149,
    x2: 360.13,
    y2: 149
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 323.63,
    y1: 123,
    x2: 360.13,
    y2: 123
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 338.63,
    y1: 10,
    x2: 338.63,
    y2: 94
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M136.63,5h125.24c23.06,0,41.76,18.7,41.76,41.76h0v47.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M206.8,370.2c-50.57,19.41-107.29-5.85-126.7-56.42-19.41-50.57,5.85-107.29,56.42-126.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "125.8 155.99 125.8 78.52 206.8 78.52 206.8 155.11"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 101.63,
    y: 34,
    width: 129,
    height: 43,
    rx: 13.79,
    ry: 13.79
  }), /*#__PURE__*/React.createElement("g", {
    className: "h"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 167.63,
    cy: 277,
    r: 128
  })), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M311.91,277.89c3.93,0,7.69-3.45,7.5-7.5-.07-4.11-3.39-7.43-7.5-7.5-3.92,0-7.68,3.45-7.5,7.5,.07,4.11,3.39,7.43,7.5,7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M319.7,309.43c3.93,0,7.68-3.45,7.5-7.5-.06-4.12-3.38-7.44-7.5-7.5-3.92,0-7.68,3.45-7.5,7.5,.07,4.11,3.39,7.43,7.5,7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M358.38,340.57c3.93,0,7.68-3.45,7.5-7.5-.07-4.11-3.39-7.43-7.5-7.5-3.92,0-7.68,3.45-7.5,7.5,.07,4.11,3.39,7.43,7.5,7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M280.51,348.11c3.92,0,7.68-3.45,7.5-7.5-.06-4.12-3.38-7.44-7.5-7.5-3.92,0-7.68,3.45-7.5,7.5,.07,4.11,3.39,7.43,7.5,7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M335.15,371.72c3.92,0,7.68-3.45,7.5-7.5-.07-4.11-3.39-7.43-7.5-7.5-3.92,0-7.68,3.45-7.5,7.5,.06,4.12,3.38,7.44,7.5,7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M132.43,254.7c3.92,0,7.68-3.45,7.5-7.5-.07-4.11-3.39-7.43-7.5-7.5-3.93,0-7.69,3.45-7.5,7.5,.06,4.12,3.38,7.44,7.5,7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M162.89,254.02c3.93,0,7.69-3.45,7.5-7.5-.07-4.11-3.39-7.43-7.5-7.5-3.92,0-7.68,3.45-7.5,7.5,.07,4.11,3.39,7.43,7.5,7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M186.55,254.36c3.93,0,7.68-3.45,7.5-7.5-.07-4.11-3.39-7.43-7.5-7.5-3.92,0-7.68,3.45-7.5,7.5,.07,4.11,3.39,7.43,7.5,7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M213.62,254.87c3.92,0,7.68-3.45,7.5-7.5-.07-4.11-3.39-7.43-7.5-7.5-3.93,0-7.68,3.45-7.5,7.5,.06,4.12,3.38,7.44,7.5,7.5Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 151.63,
    y1: 286,
    x2: 253.06,
    y2: 286
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgquimica1);
export default __webpack_public_path__ + "static/media/svgquimica1.3dd08c358289b3b4b368706a1575012f.svg";
export { ForwardRef as ReactComponent };